var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-create-drawer',{attrs:{"is-visible":_vm.value,"halls":_vm.halls,"initial-customer-ids":_vm.initialCustomerIds},on:{"close":_vm.onClose,"created":_vm.onCreated}})}
var staticRenderFns = []

export { render, staticRenderFns }